export enum Criterion {
  Event,
  Discipline,
  Region,
  Category
}
